import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/697f4db3921dc90014cea113/arti_enterprise/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/697f4db3921dc90014cea113/arti_enterprise/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697f4db3921dc90014cea113/arti_enterprise/src/app/projects/components/ProjectDetailsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697f4db3921dc90014cea113/arti_enterprise/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697f4db3921dc90014cea113/arti_enterprise/src/components/common/StickyContactButtons.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/697f4db3921dc90014cea113/arti_enterprise/src/components/ui/AppIcon.tsx");
